export default `
§ achievements.commitsAfter1500.title: Owl
§ achievements.commitsAfter1500.description: 70% of commits after 3:00 PM
§ achievements.commitsBefore1500.title: Early bird
§ achievements.commitsBefore1500.description: 70% of commits before noon
§ achievements.workEveryTime.title: Devoted worker
§ achievements.workEveryTime.description: a commit for every hour of the day
§ achievements.workNotWork.title: Shooting blanks
§ achievements.workNotWork.description: commits are there, but no tasks are closed
§ achievements.userNotWork.title: Fly-by
§ achievements.userNotWork.description: this is not their main project
§ achievements.userIsDied.title: Dead soul
§ achievements.userIsDied.description: worked, but resigned
§ achievements.lessTasks.title: Came and went
§ achievements.lessTasks.description: least closed tasks
§ achievements.moreTasks.title: Father says well done
§ achievements.moreTasks.description: most closed tasks
§ achievements.everyMessageLong.title: Master of eloquence
§ achievements.everyMessageLong.description: consistently the longest commit messages
§ achievements.everyMessageShort.title: Talkative, a spy's dream
§ achievements.everyMessageShort.description: consistently, the shortest commit messages
§ achievements.shortestName.title: Size doesn't matter
§ achievements.shortestName.description: shortest name
§ achievements.longestName.title: Azim Aziz Il Am Kadir Imran II
§ achievements.longestName.description: longest name
§ achievements.moreCommits.title: Backup master
§ achievements.moreCommits.description: most commits
§ achievements.lessCommits.title: Rare but Precise
§ achievements.lessCommits.description: least commits
§ achievements.oneCommitOneTask.title: Right on target
§ achievements.oneCommitOneTask.description: on average one commit per task
§ achievements.moreLazyDays.title: With you in spirit
§ achievements.moreLazyDays.description: most days without commits
§ achievements.lessLazyDays.title: Papa carlo
§ achievements.lessLazyDays.description: least days without commits
§ achievements.zeroLazyDays.title: Not a single break
§ achievements.zeroLazyDays.description: not a single day without commits
§ achievements.moreWorkDays.title: Valuable employee
§ achievements.moreWorkDays.description: most working days
§ achievements.moreScopes.title: Startuper
§ achievements.moreScopes.description: completed the most features
§ achievements.lessScopes.title: Dandy
§ achievements.lessScopes.description: completed the fewest features
§ achievements.moreDaysForTask.title: Snail on the slope
§ achievements.moreDaysForTask.description: tasks take longer than others
§ achievements.more2DaysForTask.title: Slow and steady
§ achievements.more2DaysForTask.description: more than two days per task
§ achievements.moreDaysInProject.title: Old-timer
§ achievements.moreDaysInProject.description: most days in the project
§ achievements.lessDaysInProject.title: And who is this?
§ achievements.lessDaysInProject.description: least days in the project
§ achievements.more90DaysInProject.title: Welcome aboard
§ achievements.more90DaysInProject.description: not fired during the probation period
§ achievements.lessDaysForTask.title: Fast shooting
§ achievements.lessDaysForTask.description: a task takes less than a day
§ achievements.adam.title: Adam
§ achievements.adam.description: the first stable employee on the project
§ achievements.more666DaysInProject.title: Devil
§ achievements.more666DaysInProject.description: worked 666 days on the project
§ achievements.more777DaysInProject.title: Las Vegas
§ achievements.more777DaysInProject.description: worked 777 days on the project
§ achievements.moreRefactoring.title: Executive editor
§ achievements.moreRefactoring.description: made the most 'refactoring' tags
§ achievements.longestMessage.title: So many conversations...
§ achievements.longestMessage.description: the longest commit message of all time
§ achievements.moreTasksInDay.title: Speed racer
§ achievements.moreTasksInDay.description: record for the number of tasks closed in a day
§ achievements.hasCommitFrom0to7.title: Night watch
§ achievements.hasCommitFrom0to7.description: a commit for every hour of the night
§ achievements.noCommitOnDay.title: Technical break
§ achievements.noCommitOnDay.description: there is a certain hour and day in working time when never commits
§ achievements.hasCommitEveryTime.title: Died at work
§ achievements.hasCommitEveryTime.description: a commit for every hour of each day (including weekends)
§ achievements.commitsAfter1800.title: Business Time
§ achievements.commitsAfter1800.description: no commits after 6:00 PM
§ achievements.moreFix.title: Bug hunter
§ achievements.moreFix.description: most closed bugs
§ achievements.lessWorkDays.title: Count me out
§ achievements.lessWorkDays.description: least working days
§ achievements.moreCreateCode.title: Creator
§ achievements.moreCreateCode.description: tends to add code more than others
§ achievements.moreRemoveCode.title: Destroyer
§ achievements.moreRemoveCode.description: tends to remove code more than others
§ achievements.moreChangeCode.title: Reformer
§ achievements.moreChangeCode.description: tends to change code more than others
§ achievements.moreStyle.title: Fashion police
§ achievements.moreStyle.description: tends to change CSS more than others
§ achievements.moreOnHoliday.title: No life
§ achievements.moreOnHoliday.description: relatively many commits in non-working hours
§ achievements.morePRMerge.title: Show me your pass
§ achievements.morePRMerge.description: more often than others, presses the "Merge" button for PR
§ achievements.longWaitPR.title: Tomorrow 100% be merge
§ achievements.longWaitPR.description: created PR that waited more than a month on the review
§ achievements.moreLongWaitPR.title: A long time ago in a galaxy far, far away
§ achievements.moreLongWaitPR.description: created PR that has been waiting for a review the longest
§ achievements.oneExtension.title: My name is LEGION
§ achievements.oneExtension.description: only this man works with files of a certain extension
§ achievements.fileRush.title: Zerg Rush
§ achievements.fileRush.description: created the most files in the project
§ achievements.moreLintHint.title: Grammar Nazi
§ achievements.moreLintHint.description: more than anyone created or changed the code-style rules
§ achievements.moreReadMe.title: Chronicler
§ achievements.moreReadMe.description: more than anyone created or modified MD files
§ achievements.moreDevOps.title: DevOps
§ achievements.moreDevOps.description: more than anyone created or modified files for CI/CD
§ achievements.moreTests.title: Tester
§ achievements.moreTests.description: more than anyone created or modified files for testing
§ achievements.allRelease.title: Full house
§ achievements.allRelease.description: there is a release compiled only from his tasks
§ achievements.firstCommit.title: First come, first served
§ achievements.firstCommit.description: first commit on the project
§ achievements.lastCommit.title: I've finished
§ achievements.lastCommit.description: last commit on the project
§ achievements.firstLastCommit.title: From beginning to end
§ achievements.firstLastCommit.description: first and last commit on the project
§ achievements.longFilePath.title: Deep cellar
§ achievements.longFilePath.description: the first created the file with the deepest directory
§ achievements.longFileName.title: Size matters
§ achievements.longFileName.description: created the file with the longest name
§ achievements.workOnWeekends.title: Work not walk
§ achievements.workOnWeekends.description: at least once worked on weekends
§ achievements.removeCreateFile.title: Dig out the stewardess
§ achievements.removeCreateFile.description: recover removed file
§ achievements.renameFile.title: Astana Nur-Sultan Astana
§ achievements.renameFile.description: rename file and rollback
§ achievements.longTask.title: Easy task
§ achievements.longTask.description: worked on task more than three months
§ achievements.haveNotEmail.title: Mailman
§ achievements.haveNotEmail.description: empty email field in git config
§ achievements.moreAddedFolders.title: Director 
§ achievements.moreAddedFolders.description: created the most directories
§ achievements.horoscope1.title: Mercury Retrograde for Capricorn
§ achievements.horoscope2.title: Mercury Retrograde for Aquarius
§ achievements.horoscope3.title: Mercury Retrograde for Pisces
§ achievements.horoscope4.title: Mercury Retrograde for Aries
§ achievements.horoscope5.title: Mercury Retrograde for Taurus
§ achievements.horoscope6.title: Mercury Retrograde for Gemini
§ achievements.horoscope7.title: Mercury Retrograde for Cancer
§ achievements.horoscope8.title: Mercury Retrograde for Leo
§ achievements.horoscope9.title: Mercury Retrograde for Virgo
§ achievements.horoscope10.title: Mercury Retrograde for Libra
§ achievements.horoscope11.title: Mercury Retrograde for Scorpio
§ achievements.horoscope12.title: Mercury Retrograde for Sagittarius
§ achievements.horoscope1.description: by the month of the first commit
§ achievements.horoscope2.description: by the month of the first commit
§ achievements.horoscope3.description: by the month of the first commit
§ achievements.horoscope4.description: by the month of the first commit
§ achievements.horoscope5.description: by the month of the first commit
§ achievements.horoscope6.description: by the month of the first commit
§ achievements.horoscope7.description: by the month of the first commit
§ achievements.horoscope8.description: by the month of the first commit
§ achievements.horoscope9.description: by the month of the first commit
§ achievements.horoscope10.description: by the month of the first commit
§ achievements.horoscope11.description: by the month of the first commit
§ achievements.horoscope12.description: by the month of the first commit
§ achievements.111.description: test
`;
